module.exports = __webpack_public_path__ + "static/img/solution_evaluating.76eff4bd.png";